import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Stack, Typography} from '@mui/material';
import {useRef} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";
const sha256 = require('sha256');

export default function ResetPasswordDialog(props: {state: any, setState: any}) {
    console.log('[ResetPasswordDialog]');

    const handleClose = () => {
        props.setState({
            ...props.state,
            openResetPassword: false,
        });
    };

    let userNoRef: any = useRef();
    let phoneNoRef: any = useRef();
    let messageRef: any = useRef();

    function handleChangePassword() {
        let userNo = userNoRef.current.value;
        let phoneNo = phoneNoRef.current.value;

        if (userNo == '') {
            messageRef.current.innerText = '사원번호를 입력해주세요.'
            return;
        }

        if (phoneNo.length < 8) {
            messageRef.current.innerText = '핸드폰번호를 입력해주세요.'
            return;
        }

        let params: any = {
            userNo: userNo,
            phoneNo: phoneNo,
        };
        axios.post(constance.api.resetPassword, {
            ...params,
        }).then(value => {
            common.alert('', value.data.message, 'info');
            props.setState({
                ...props.state,
                openResetPassword: false
            });
        }).catch(reason => {
            common.alert('', reason.data.message, 'info');
        }).finally(() => {
            // userNoRef.current.value = '';
        });
    }


    return (
        <div>
            <Dialog open={props.state.openResetPassword} onClose={handleClose} sx={{maxHeight: '100vh'}}>
                <DialogTitle>
                    <Box sx={{display: 'flex'}}>
                        <Typography variant={'h5'}>
                            {`비밀번호 초기화`}
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent >
                    <DialogContentText>
                        <Stack sx={{width: {xs: 250, sm: 300, md: 400}}}>
                            <Box sx={{mt: 2}}>
                                <TextField
                                    inputRef={userNoRef}
                                    autoFocus
                                    margin="dense"
                                    label="사원번호"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                />
                            </Box>

                            <Box sx={{mt: 1}}>
                                <TextField
                                    inputRef={phoneNoRef}
                                    margin="dense"
                                    label="핸드폰번호"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                />
                            </Box>
                            <Box sx={{display: 'flex', justifyContent: 'center', mt: 1}}>
                                <Typography ref={messageRef}
                                            color={'red'}
                                            variant={'subtitle1'}>
                                    {` `}
                                </Typography>
                            </Box>
                        </Stack>
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>닫기</Button>
                    <Button onClick={handleChangePassword}>확인</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
